module.exports = __webpack_public_path__ + "img/BRCA2_CD4Tconv.82fb2355.png";